<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="نبذة-عن-الكتاب-على-الغلاف-الخلفي">
<h1><span dir="rtl">نبذة عن الكتاب على الغلاف الخلفي</span></h1>
<p><span dir="rtl">فابريس <em>چومون</em> الملقب بـ "عرّاب برامج الدمج اللغوي" من قِبل صحيفة نيويورك تايمز في عام 2014، وهو الملحق<em> التعليمي والثقافي لسفارة فرنسا في الولايات المتحدة،</em> لديه أكثر من 25 عاماً من الخبرة في مجال التعليم الدولي وتطوير البرامج متعددة اللغات.</span></p>
<p><span dir="rtl">حصل چومون على درجة الدكتوراه في التعليم الدولي من جامعة نيويورك (</span>NYU<span dir="rtl">) كما حصل على عدة جوائز وأوسمة مثل "وسام النخلة" الأكاديمي، وهو وسام استحقاق من الحكومة الفرنسية، وجائزة التنوع الثقافي من المنظمة الدولية للفرانكفونية لدى الأمم المتحدة، ووسام الاعتراف من مؤسسة</span> CAF USA<span dir="rtl">.</span></p>
<p><span dir="rtl">وضع <em>چومون</em> خبرته مباشرة في خدمة المجتمعات الفرنسية والإيطالية واليابانية والألمانية والروسية</span> <span dir="rtl">في الولايات المتحدة؛ من خلال مساعدتهم على تطوير برامج ثنائية اللغة ذات جودة عالية في المدارس الحكومية المحلية.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?396cfab0